import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tootekood

  <span style="color:#85c1dc;">**FI:**</span>
  Tuotekoodi

  <span style="color:#85c1dc;">**RU:**</span>
  Код продукта
*/
/* @__NO_SIDE_EFFECTS__ */
const m419 = msg(
  mf`Tootekood`,
  mf`Tuotekoodi`,
  mf`Код продукта`,
)

export { m419 as 'w.product.product_code' }